import { useEffect, useRef, useState } from 'react'

export default function useHover<T extends Element = HTMLElement>() {
  const [value, setValue] = useState(false)

  const ref = useRef<T>(null)
  // var to store timer id between hook calls
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    const node = ref.current

    if (node) {
      const handleMouseOver = () => {
        if (timerRef.current) {
          clearTimeout(timerRef.current)
        }

        timerRef.current = setTimeout(() => {
          setValue(true)
        }, 0)
      }
      const handleMouseOut = () => {
        if (timerRef.current) {
          clearTimeout(timerRef.current)
        }

        timerRef.current = setTimeout(() => {
          setValue(false)
        }, 0)
      }

      node.addEventListener('mouseover', handleMouseOver)
      node.addEventListener('mouseout', handleMouseOut)

      return () => {
        node.removeEventListener('mouseover', handleMouseOver)
        node.removeEventListener('mouseout', handleMouseOut)
      }
    }
    return () => {}
  }, [])

  return [ref, value] as const
}
